<template>
  <b-modal id="edit_note_modal" ref="edit_note_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <!-- Different modal header depending on type note being left -->
        <h1>
          <i class="fas fa-comment-dots"></i>
          <span v-if="$store.state.notes.type === 'company'">Edit Company Note</span>
          <span v-else-if="$store.state.notes.type === 'contact'">Edit Contact Note</span>
          <span v-else-if="$store.state.notes.type === 'order_job'">Edit Order Note</span>
          <span v-else-if="$store.state.notes.type === 'worker'">Edit Worker Note</span>
        </h1>
        <p id="mh-info">Edit note on {{ $store.state.notes.name }}</p>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>
    <div>
      <ValidationObserver ref="editNoteForm" slim>
        <form role="form" @submit.prevent="update_note()">
          <div class="row">
            <div class="col-12 form-group" v-if="$store.state.notes.type === 'company' && $store.state.notes.contacts !== null">
              <label class="form-label" for="company_name">Company Name</label>
              <input :value="$store.state.notes.name" name="company_name" type="text" class="form-input disabled" id="company_name" readonly>
            </div>

            <div class="col-12 form-group" v-if="$store.state.notes.type === 'contact'">
              <label class="form-label" for="contact_name">Contact Name</label>
              <input :value="$store.state.notes.name" name="contact_name" type="text" class="form-input disabled" id="contact_name" readonly>
            </div>

            <div class="col-12 form-group">
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Note Type" tag="div">
                <label class="form-label" for="note_type">Note Type</label>
                <multiselect v-model="note.type" placeholder="" id="note_type" label="note_type" track-by="id" :options="ms_opts.note_type" :option-height="200"
                             :custom-label="note_type_label" :show-labels="false" class="requiredField" :class="classes"
                             group-values="data" group-label="header">
                </multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div :class="[note.is_call ? 'col-6' : 'col-12']">
              <div class="row">
                <label :class="[note.is_call ? 'col-7 cardLabel' : 'col-8 cardLabel']" for="is_call">Call Note</label>
                <div :class="[note.is_call ? 'col-5 cardLabel' : 'col-4 cardLabel']">
                  <bootstrap-toggle v-model="note.is_call" name="is_call" id="is_call" :options="{ on: 'Yes', off: 'No' }"
                                    @input="is_call_click"/>
                </div>
              </div>
            </div>
            <div class="col-6" v-if="note.is_call">
              <div class="row">
                <label class="col-7 cardLabel" for="voicemail">Left Voicemail</label>
                <div class="col-5">
                  <bootstrap-toggle v-model="note.voicemail" name="voicemail" id="voicemail" :options="{ on: 'Yes', off: 'No' }"
                                    @input="voicemail_click"/>
                </div>
              </div>
            </div>
            <div class="col-12 form-group" v-if="note.is_call">
              <ValidationProvider :rules="{'required' : note.is_call}" v-slot="{errors, classes}" name="Type of Call" tag="div">
                <label class="form-label" for="call_type">Type of Call</label>
                <multiselect v-model="note.call_type" placeholder="" id="call_type" :options="ms_opts.call_type"
                             class="requiredField" :class="classes" :disabled="note.voicemail">
                </multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="col-12" v-if="$store.state.notes.type !== 'worker'">
              <div class="row">
                <label class="col-md-8 cardLabel" for="decision_maker">Decision Maker</label>
                <div class="col-md-4">
                  <bootstrap-toggle v-model="note.decision_maker" name="decision_maker" id="decision_maker" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>
            <div :class="[note.discussed_tax ? 'col-6' : 'col-12']" v-if="$store.state.notes.type === 'worker' && note.is_call && !note.voicemail">
              <div class="row">
                <label :class="[note.discussed_tax ? 'col-7 cardLabel' : 'col-8 cardLabel']" for="discussed_tax">Discussed Tax?</label>
                <div :class="[note.discussed_tax ? 'col-5 cardLabel' : 'col-4 cardLabel']">
                  <bootstrap-toggle v-model="note.discussed_tax" name="discussed_tax" id="discussed_tax" :options="{ on: 'Yes', off: 'No' }"
                                    @input="discussed_tax_click"/>
                </div>
              </div>
            </div>
            <div class="col-6" v-if="$store.state.notes.type === 'worker' && note.discussed_tax && !note.voicemail">
              <div class="row">
                <label class="col-7 cardLabel" for="sold_tax">Sold Tax</label>
                <div class="col-5">
                  <bootstrap-toggle v-model="note.sold_tax" name="sold_tax" id="sold_tax" :options="{ on: 'Yes', off: 'No' }"/>
                </div>
              </div>
            </div>

            <div class="col-12 form-group">
              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Note Content" tag="div">
                <label class="form-label" for="note_content">Note Content</label>
                <textarea v-model="note.note" rows="15" name="note_content" class="form-input resize_vertical requiredField" :class="classes" id="note_content"></textarea>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="col-12">
              <div class="float-right">
                <button type="submit" class="btn orcaBtn">SAVE and CLOSE</button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import BootstrapToggle from 'vue-bootstrap-toggle';

export default {
  name: "edit_note",
  components: {
    Multiselect,
    BootstrapToggle
  },
  data() {
    return {
      company_note_on: {company_id: this.$store.state.notes.id, contact_id: '', name: 'Company Record', job_title: this.$store.state.notes.name},

      ms_opts: {
        note_type: [],
        call_type: ['Incoming', 'Outgoing']
      },
      note: {
        note_logs: {},
        note_log_by: {},
        belongs_to: {},
        note_type: {},
      },
    }
  },
  mounted() {
    axios.get(this.crmApiPath + 'note/' + this.$store.state.notes.id).then(note => {
      this.note = note.data;
      this.note.type = note.data.note_type;
      this.note.type.division = note.data.type.division.division;
    });
    if (this.$store.state.notes.type === 'company' || this.$store.state.notes.type === 'contact') {
      this.ms_opts.note_type = this.$store.state.crm_options.note_types.company;
    }
    else if (this.$store.state.notes.type === 'worker') {
      this.ms_opts.note_type = this.$store.state.crm_options.note_types.worker;
    }
    else if (this.$store.state.notes.type === 'order_job') {
      this.ms_opts.note_type = this.$store.state.crm_options.note_types.order_job;
    }
  },
  methods: {
    note_type_label({division, note_type}) {
      return `[${division}] - ${note_type}`
    },
    hideModal() {
      this.$refs.edit_note_modal.hide();
      this.$store.commit('HIDE_NOTE_MODALS');
    },
    update_note() {
      this.$refs.editNoteForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editNoteForm);
        }
        else {
          this.note.log_by_id = this.$store.state.auth.me.id;
          this.note.log_by_type = 'App\\Models\\Users\\User';
          this.note.note_type_id = this.note.type.id;

          axios.patch(this.crmApiPath + 'note/' + this.$store.state.notes.id, this.note).then(() => {
            this.$snotify.success('Note updated for ' + this.$store.state.notes.name);
            this.$bus.$emit('note::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            if (this.$store.state.notes.type === 'company' || this.$store.state.notes.type === 'contact') {
              this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
            }
            this.hideModal();
          })
        }
      });
    },
    is_call_click() {
      if (!this.note.is_call) {
        this.note.voicemail = false;
        this.note.discussed_tax = false;
        this.note.decision_maker = false;
        this.note.call_type = null;
      }
    },
    voicemail_click() {
      if (!this.note.voicemail) {
        this.note.discussed_tax = false;
        this.note.decision_maker = false;
        this.note.call_type = null;
      }
      if (this.note.voicemail) {
        this.note.call_type = 'Outgoing';
      }
    },
    discussed_tax_click() {
      if (!this.note.discussed_tax) {
        this.note.sold_tax = false;
      }
    }
  },
}
</script>
<style lang="scss">
#edit_note_modal {
  .multiselect__option {
    height: auto !important;
  }

  .option__desc {
    .option__title {
      font-weight: bold;
      display:     block;
    }

    .option__small {
      font-size: 0.7rem;
      display:   block;
    }
  }
}
</style>
